import { useEffect, useState } from 'react';
import { Grid, Container, Typography, Card, CardContent, Dialog, DialogContent } from '@mui/material';
import { useLocation, useHistory } from 'react-router-dom';
import Navbar from '../Navbar';
import { ThemeClient } from '../contexts/Theme';
import { Spotify } from 'react-spotify-embed';
import CardBtn from '../components/CardBtn';
import Video from '../components/Video';
import LanguageIcon from '@mui/icons-material/Language';
import BookIcon from '@mui/icons-material/Book';
import { supabase } from '../supabaseClient';
import Navegation from '../components/Navegation'
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useCompany } from '../contexts/Company';

const LibraryItem = ({ item, handleOpen }) => {
  const { type, title, url } = item;

  if (type === 'youtube') {
    const videoId = url.match(/(?:youtu\.be\/|youtube\.com(?:\/embed\/|\/v\/|\/watch\?v=|\/user\/\S+|\/ytscreeningroom\?v=))([\w\-]{10,12})\b/);
    if (videoId) {
      return <Video id={videoId[1]} title={title} />;
    } else {
      return null
    }
  }

  if (type === 'podcast') {
    return <Spotify link={url} wide={true} />;
  }

  if (type === 'article') {
    return <CardBtn onClick={(e) => handleOpen(url)} text={title} icon={<LanguageIcon />} />;
  }

  if (type === 'book') {
    return <CardBtn onClick={(e) => handleOpen(url)} text={title} icon={<BookIcon />} />;
  }

  return null;
};

export default function VirtualLibrary() {
  const location = useLocation();
  const history = useHistory();
  const category = new URLSearchParams(location.search).get('category');
  const company = useCompany();

  const [currentCategoryName, setCurrentCategoryName] = useState(category);
  const [libraryItems, setLibraryItems] = useState([]);

  const [open, setOpen] = useState(false);
  const [url, setUrl] = useState('');

  const handleOpen = (url) => {
    if (url.includes('amazon')) {
      window.open(url, '_blank');
    } else {
      setOpen(true);
      setUrl(url);
    }
  };

  useEffect(() => {
    if (company?.id == 45) {
      switch (category) {
        case 'podcast':
          setCurrentCategoryName('Podcasts');
          break;
        case 'youtube':
          setCurrentCategoryName('Videos');
          break;
        case 'article':
          setCurrentCategoryName('Articles');
          break;
        case 'book':
          setCurrentCategoryName('Books');
          break;
      }
    } else {
      switch (category) {
        case 'podcast':
          setCurrentCategoryName('Podcasts');
          break;
        case 'youtube':
          setCurrentCategoryName('Videos');
          break;
        case 'article':
          setCurrentCategoryName('Artículos');
          break;
        case 'book':
          setCurrentCategoryName('Libros');
          break;
      }
    }
    const fetchLibraryItems = async () => {
      if (!company) return
      console.log(company?.language)
      const { data, error } = await supabase
        .from('library')
        .select('*')
        .eq('type', category)
        .eq('language', company?.language);
      if (error) {
        console.error('Error fetching library items:', error);
      } else {
        setLibraryItems(data);
      }
    };

    fetchLibraryItems();
  }, [category, company]);

  return (
    <ThemeClient>
      <Navbar title={currentCategoryName} back={true} />

      <Dialog open={open} onClose={() => setOpen(false)} PaperProps={{
        style: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
          width: '100%',
          height: '100%',
        },
      }}>
        <DialogContent style={{ padding: 0, height: '100%' }}>
          <IconButton
            edge="end"
            color="inherit"
            onClick={() => setOpen(false)}
            style={{
              position: 'absolute',
              top: 8,
              right: 8,
              zIndex: 1,
            }}
          >
            <CloseIcon />
          </IconButton>
          <iframe src={url} style={{ width: '100%', height: '100%', border: 'none', 'overflow-y': 'hidden',background: 'white' }}
          />
        </DialogContent>
      </Dialog>

      <Container component="main" maxWidth="sm" sx={{ marginTop: 2 }}>
        <Card sx={{ marginTop: 2, padding: 1 }}>
          {libraryItems.map((item) => (
            <LibraryItem handleOpen={handleOpen} key={item.id} item={item} />
          ))}
        </Card>
      </Container>
      <Navegation />
    </ThemeClient>
  );
};
